"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DebounceStrategy = require("./DebounceStrategy");
var DropStrategy = require("./DropStrategy");
var INetworkAdapter = require("./INetworkAdapter");
var STRATEGIES = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, DebounceStrategy.DEBOUNCE, DebounceStrategy), DropStrategy.DROP, DropStrategy);
var ThrottlerAdapter = /*#__PURE__*/function (_INetworkAdapter) {
  function ThrottlerAdapter(adapter, config) {
    var _this;
    (0, _classCallCheck2["default"])(this, ThrottlerAdapter);
    _this = _callSuper(this, ThrottlerAdapter);
    (0, _defineProperty2["default"])(_this, "_adapter", null);
    (0, _defineProperty2["default"])(_this, "_config", null);
    (0, _defineProperty2["default"])(_this, "_strategy", null);
    _this._adapter = adapter;
    _this._config = config;
    return _this;
  }
  (0, _inherits2["default"])(ThrottlerAdapter, _INetworkAdapter);
  return (0, _createClass2["default"])(ThrottlerAdapter, [{
    key: "getURLSignature",
    value: function getURLSignature(urlString, method) {
      var url = new URL(urlString);
      return "".concat(method, "-").concat(url.origin).concat(url.pathname);
    }
  }, {
    key: "_selectStrategy",
    value: function _selectStrategy() {
      var _this$_strategy;
      var selectedStrategy = this._config.get("network.throttle.strategy");
      if (!STRATEGIES[selectedStrategy]) {
        return null;
      }
      if (((_this$_strategy = this._strategy) === null || _this$_strategy === void 0 ? void 0 : _this$_strategy.key) !== selectedStrategy) {
        this._strategy = new STRATEGIES[selectedStrategy].build(this._config);
      }
      return this._strategy;
    }
  }, {
    key: "_runStrategy",
    value: function _runStrategy() {
      var currentStrategy = this._selectStrategy();
      if (!currentStrategy) {
        return Promise.resolve();
      }
      return currentStrategy.run.apply(currentStrategy, arguments);
    }
  }, {
    key: "get",
    value: function get(url, config) {
      var _this2 = this;
      for (var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        params[_key - 2] = arguments[_key];
      }
      var urlSignature = this.getURLSignature(url, "GET");
      return this._runStrategy(urlSignature, config).then(function () {
        var _this2$_adapter;
        return (_this2$_adapter = _this2._adapter).get.apply(_this2$_adapter, [url, config].concat(params));
      });
    }
  }, {
    key: "post",
    value: function post(url, body, config) {
      var _this3 = this;
      for (var _len2 = arguments.length, params = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        params[_key2 - 3] = arguments[_key2];
      }
      var urlSignature = this.getURLSignature(url, "POST");
      return this._runStrategy(urlSignature, config).then(function () {
        var _this3$_adapter;
        return (_this3$_adapter = _this3._adapter).post.apply(_this3$_adapter, [url, body, config].concat(params));
      });
    }
  }, {
    key: "put",
    value: function put(url, body, config) {
      var _this4 = this;
      for (var _len3 = arguments.length, params = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
        params[_key3 - 3] = arguments[_key3];
      }
      var urlSignature = this.getURLSignature(url, "PUT");
      return this._runStrategy(urlSignature, config).then(function () {
        var _this4$_adapter;
        return (_this4$_adapter = _this4._adapter).put.apply(_this4$_adapter, [url, body, config].concat(params));
      });
    }
  }, {
    key: "delete",
    value: function _delete(url, config) {
      var _this5 = this;
      for (var _len4 = arguments.length, params = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        params[_key4 - 2] = arguments[_key4];
      }
      var urlSignature = this.getURLSignature(url, "DELETE");
      return this._runStrategy(urlSignature, config).then(function () {
        var _this5$_adapter;
        return (_this5$_adapter = _this5._adapter)["delete"].apply(_this5$_adapter, [url, config].concat(params));
      });
    }
  }]);
}(INetworkAdapter);
exports = module.exports = ThrottlerAdapter;